import React from 'react';
import { Navigate } from 'react-router-dom';
import { Layout } from '../layout/Layout';

const ProtectedRoute = ({ children }) => {
    // Check localStorage for authentication
    const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

    // If not authenticated, redirect to login page
    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    // If authenticated, render the children (protected component)
    return <Layout>{children}</Layout>
};

export default ProtectedRoute;
